import { Module } from 'vuex'
import { RootState } from '@/store'
import { mutations } from '@/store/modules/family/mutations'
import { IFamilyState, initialState } from '@/store/modules/family/state'

export * from '@/store/modules/family/state'

export const store: Module<IFamilyState, RootState> = {
  state: initialState,
  mutations
}
